// @flow
import invariant from 'invariant';
import * as React from 'react';
import MultiDatePicker from 'components/MultiDatePicker';
import Field from './Field';

const MultiDatePickerField = ({
  name,
  label,
  description,
  maxInputs,
  disabled,
  ...props
}: {
  name: string,
  label?: string,
  description?: string,
  maxInputs: number,
  disabled?: boolean
}) => (
  <Field
    inputProps={props}
    name={name}
    label={label}
    description={description}
    renderInput={({ value, id, qaId, hasError, updateValue }) => {
      invariant(Array.isArray(value), 'Invalid value for MultiDatePickerField');
      return (
        <MultiDatePicker
          id={id}
          name={name}
          values={value}
          maxInputs={maxInputs}
          hasError={hasError}
          data-qa-id={qaId}
          onChange={updateValue}
          disabled={disabled}
          {...props}
        />
      );
    }}
  />
);

export default MultiDatePickerField;
